module.exports = {"header":{"portalName":"uMotif 入口網站"},"message":{"error":{"default":"抱歉，發生了一個錯誤。","invalidCode":"輸入的代碼無效。請再試一次。"}}}